import "../../../../../../styles.css";
import { Head, Image, Appear, Notes, Invert, Split } from "mdx-deck";
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { shadesOfPurple } from "@code-surfer/themes";
import theme from "../../../../../../theme";
import thanos from "../../../../../../static/thanos_logo.svg";
import prometheus from "../../../../../../static/prometheus_logo.svg";
import redhat from "../../../../../../static/red_hat_logo.png";
import bartek from "../../../../../../static/bartek.jpeg";
import kemal from "../../../../../../static/kemal.jpeg";
import twitter from "../../../../../../static/twitter.png";
import github from "../../../../../../static/github.png";
import d01 from "../../../../../../static/d01.png";
import d02 from "../../../../../../static/d02.png";
import d03 from "../../../../../../static/d03.png";
import d05 from "../../../../../../static/d05.png";
import d06 from "../../../../../../static/d06.png";
import d08 from "../../../../../../static/d08.png";
import d09 from "../../../../../../static/d09.png";
import d11 from "../../../../../../static/d11.png";
import graph_requests from "../../../../../../static/graph-requests.png";
import d10 from "../../../../../../static/d10.png";
import pitfalls from "../../../../../../static/pitfall.gif";
import magic from "../../../../../../static/magic.gif";
import testing from "../../../../../../static/testing.gif";
import d12 from "../../../../../../static/d12.png";
import d13 from "../../../../../../static/d13.png";
import d14 from "../../../../../../static/d14.png";
import d15 from "../../../../../../static/d15.png";
import d16 from "../../../../../../static/d16.png";
import harry_potter from "../../../../../../static/harry_potter.gif";
import itisfine from "../../../../../../static/itisfine.jpg";
import ss_repo from "../../../../../../static/ss_repo.png";
import red_hat_white from "../../../../../../static/red_hat_white.png";
import React from 'react';
export default {
  Head: Head,
  Image: Image,
  Appear: Appear,
  Notes: Notes,
  Invert: Invert,
  Split: Split,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  shadesOfPurple: shadesOfPurple,
  theme: theme,
  thanos: thanos,
  prometheus: prometheus,
  redhat: redhat,
  bartek: bartek,
  kemal: kemal,
  twitter: twitter,
  github: github,
  d01: d01,
  d02: d02,
  d03: d03,
  d05: d05,
  d06: d06,
  d08: d08,
  d09: d09,
  d11: d11,
  graph_requests: graph_requests,
  d10: d10,
  pitfalls: pitfalls,
  magic: magic,
  testing: testing,
  d12: d12,
  d13: d13,
  d14: d14,
  d15: d15,
  d16: d16,
  harry_potter: harry_potter,
  itisfine: itisfine,
  ss_repo: ss_repo,
  red_hat_white: red_hat_white,
  React: React
};